import { rejected, resolved } from '../../createAction';
import {
  GET_UNREAD_NOTIFICATIONS,
  MARK_READ,
  NEW_NOTIFICATION_RECEIVED,
} from './types';

const initialState = {
  loading: false,
  data: [],
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case GET_UNREAD_NOTIFICATIONS: {
      return {
        ...state,
        loading: true,
      };
    }
    case resolved(GET_UNREAD_NOTIFICATIONS): {
      return {
        ...state,
        loading: false,
        data: payload,
      };
    }
    case rejected(GET_UNREAD_NOTIFICATIONS): {
      return {
        ...state,
        loading: false,
      };
    }
    case NEW_NOTIFICATION_RECEIVED: {
      return {
        ...state,
        data: [payload, ...state.data],
      };
    }
    case resolved(MARK_READ): {
      return {
        ...state,
        data: state.data.filter((i) => i.hash !== meta.hash),
      };
    }
    default:
      return state;
  }
};
